/**
 * Registration schedule-replace rematch / paint policy (#1561).
 *
 * Worker rematch always uses `notifyPresentation: false`. VBuffer owns authority + surface.
 * Paint must not rely on the framePresentation listener while suppress is latched — that
 * listener no-ops and leaves presentation≫worker with an orphan residual.
 */

/** Studio assigned a wholly different playlist — no shared identity with the prior loop / hold. */
export function isFullPlaylistReplaceMatchTier(matchTier: string): boolean {
  return matchTier === 'full-replace-no-overlap'
}

/**
 * Full replace must suppress old-plan presentation during asset rebuild. Otherwise the
 * early surface clear is undone by ticks while the bootstrap waiter is open (#1561).
 */
export function shouldSuppressPresentationDuringRegistrationAssetRebuild(
  matchTier: string
): boolean {
  return isFullPlaylistReplaceMatchTier(matchTier)
}

/**
 * After `registrationScheduleReplace` rematches the worker, force-set presentation even if
 * the resync generation was invalidated — skipping leaves sticky presentation≫worker.
 */
export function shouldForcePresentationAlignAfterWorkerRematch(
  didWorkerRematch: boolean
): boolean {
  return didWorkerRematch
}

/**
 * Non-silent rematch must sync-commit the surface from the new plan. Listener notify under
 * suppress is dropped; silent bootstrap keeps the already-matching pixels.
 */
export function shouldSyncCommitRegistrationRematchPresentation(input: {
  silentBootstrap: boolean
}): boolean {
  return !input.silentBootstrap
}
